import { ElementState, Preview } from "@creatomate/preview";
import { ElementSource, Subtitle, SubtitleSection } from "chq";

const deleteSections = async (
  subtitles: Subtitle[],
  element: ElementState,
  preview: Preview,
  onUpdateSubtitles: (newData: Record<string, any>) => void
): Promise<void> => {
  const updatedSubtitles: Subtitle[] = [];
  const idsToRemove: string[] = [];
  for (let subtitleIndex = 0; subtitleIndex < subtitles.length; subtitleIndex += 1) {
    const subtitle = subtitles[subtitleIndex];
    const updatedSections: SubtitleSection[] = [];
    for (let sectionIndex = 0; sectionIndex < (subtitle.sections?.length || 0); sectionIndex += 1) {
      const section = (subtitle.sections || [])[sectionIndex];
      const isContained = (element.globalTime - 0.1) <= section.startTime
        && (element.globalTime + element.duration + 0.1) >= section.endTime;
      // 0.1 is a tolerance value
      if (isContained) {
        if (section.creatomateId) idsToRemove.push(section.creatomateId);
      } else {
        updatedSections.push({ ...section });
      }
    }
    updatedSubtitles.push({ ...subtitle, sections: updatedSections });
  }
  const source = preview.getSource();
  await preview.setSource({
    ...source,
    elements: source.elements.filter((element: ElementSource) => !idsToRemove.includes(element.id))
  }, false);
  onUpdateSubtitles({ sutbitles: updatedSubtitles });
};

export default deleteSections;
